import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    FormControl,
    TextField,
    Paper,
    Button,
    IconButton,
    Tooltip,
    Stack,
    useTheme,
    LinearProgress,
    Select,
    MenuItem,
    InputLabel,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import useMediaQuery from "@mui/material/useMediaQuery";
import {
    fetchApidata,
    explorePostData,
    postData,
    getFetchData,
    requestMail,
    getLeaveentryData,
    RegGetData,
    PermissionApprovalVerify,
} from "../../store/reducers/Formapireducer";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import FileListPopup from "../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../ui-components/FileUploadButton";
import { attachmentPost } from "../../store/reducers/LoginReducer";
import GradingIcon from "@mui/icons-material/Grading";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../Theme";
import store from "../../index";
import { LoadingButton } from "@mui/lab";
import { fetchExplorelitview } from "../../store/reducers/Explorelitviewapireducer";
import { toast } from "react-hot-toast";
import { Productautocomplete } from "../../ui-components/global/Autocomplete";
import { formGap } from "../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../store/reducers/Listviewapireducer";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import CryptoJS from "crypto-js";


const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
function decryptDataUrlSafe(urlSafeBase64) {
    // Convert back to standard base64
    let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if needed
    while (base64.length % 4 !== 0) {
        base64 += "=";
    }

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(base64) },
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}
const Regularizationaproval = () => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    const params = useParams();
    const [responseMsg, setResponseMsg] = useState(false);
    const [checkIN, setCheckIN] = useState("");
    const [open, setOpen] = useState(false);

    const location = useLocation();
    const rowData = location.state || {};
    const [files, setFiles] = useState([]);
    const [error, setError] = useState("");
    const rowSx = { height: 36, "& td, & th": { py: 0.5 } };

    const mode = params.Mode;
    const listViewData = useSelector((state) => state.listviewApi.rowData);
    const listViewColumn = useSelector((state) => state.listviewApi.columnData);

    const explorelistViewData = useSelector(
        (state) => state.exploreApi.explorerowData
    );
    const explorelistViewColumn = useSelector(
        (state) => state.exploreApi.explorecolumnData
    );
    const RegData = useSelector((state) => state.formApi.RegGetData);
    const getLoading = useSelector((state) => state.formApi.getLoading);
    const LeaveEntryData = useSelector((state) => state.formApi.LeaveEntryData);
    console.log(RegData, "--RegData");

    const data = useSelector((state) => state.formApi.Data);
    const isLoading = useSelector((state) => state.formApi.loading);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [show, setScreen] = React.useState("0");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const Data = useSelector((state) => state.formApi.Data);
    const [openDEPopup, setOpenDEPopup] = useState(false);
    const [openADPopup, setOpenADPopup] = useState(false);
    const [openLETPopup, setOpenLETPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const EMPID = sessionStorage.getItem("EmpId");
    const compID = sessionStorage.getItem("companyId");
    var accessID = "TR219";
    const currentDate = new Date().toISOString().split("T")[0];
    const exploreLoading = useSelector((state) => state.exploreApi.loading);
    const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
    const EmpName = sessionStorage.getItem("EmpName");
    const VISIBLE_FIELDS = ["SLNO", "Date", "NumberOfHours", "action"];
    const columns = React.useMemo(
        () =>
            explorelistViewColumn
                ? explorelistViewColumn.filter((column) =>
                    VISIBLE_FIELDS.includes(column.field)
                )
                : [],
        [explorelistViewColumn]
    );
    useEffect(() => {
        dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
            console.log(res, "response");

            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: data.EmployeeID,
                        appId: recID,
                    },
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError("Failed to fetch attachments.");
                    console.error(err);
                })
                .finally(() => setLoading(false));
        })
    }, []);
    const [selectedLeavetypeOptions, setSelectedLeavetypeOptions] =
        useState(null);
    const [selectedLeavetypeid, setSelectedLeavetypeid] = useState(null);
    const [selectedLeavetypeName, setSelectedLeavetypeName] = useState(null);

    const handleSelectionLeavetypename = (newValue) => {
        if (newValue) {
            //Leavetype
            setSelectedLeavetypeOptions(newValue);
            console.log(newValue, "--setSelectedLeavetypeOptions");
            setSelectedLeavetypeid(newValue.RecordID);

            //setSelectedLeavetypeid(newValue.LeavetypeRecordID);
            setSelectedLeavetypeName(newValue.Name);
        } else {
            setSelectedLeavetypeOptions(null);
            setSelectedLeavetypeid(null);
            setSelectedLeavetypeName(null);
        }
    };

    var userimg = store.getState().globalurl.imageUrl;
    if (mode === "A" || !data?.ImageName) {
        userimg = userimg + "Defaultimg.jpg";
    } else {
        userimg = userimg + data.ImageName;
    }

    const fnLogOut = (props) => {
        Swal.fire({
            title: `Do you want ${props}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") navigate("/");
                if (props === "Close") navigate(-1);
            }
        });
    };

    // let params = useParams();
    const dispatch = useDispatch();
    var recID = decryptDataUrlSafe(params.id);


    // var mode = params.Mode;

    /*************************LOOKUP DATA*********************/
    const [openLTpopup, setOpenLTpopup] = useState(false);

    function handleShow(type) {
        if (type == "LT") {
            setOpenLTpopup(true);
        }
    }
    const [isPopupData, setisPopupdata] = React.useState(false);
    const [selectltLookupData, setselectLTLookupData] = React.useState({
        LTlookupID: "",
        LTlookupCode: "",
        LTlookupDesc: "",
    });

    if (isPopupData == false) {
        selectltLookupData.LTlookupID = Data.LeaveTypeID;
        selectltLookupData.LTlookupCode = Data.LeaveTypeCode;
        selectltLookupData.LTlookupDesc = Data.LeaveTypeName;
    }

    const RegInitialValue = {
        Name: mode === "A" ? RegData.EmployeeName : data.EmployeeName,
        CheckInDate:
            mode === "A" ? RegData.CheckInDate || checkIN : data.CheckInDate,
        CheckOutDate: mode === "A" ? RegData.CheckOutDate : data.CheckOutDate,
        MonthDate: mode === "A" ? currentDate : data.RegularizationDate,
        EmplyeeCheckInDateTime:
            mode === "A" ? RegData.CheckInTime : data.NewCheckInTime,
        // oldCheckinTime: mode === "A" ? RegData.CheckOutDate : data.CheckInTime,
        // oldcheckoutTime: mode === "A" ? RegData.CheckOutDate : data.CheckInTime,
        oldCheckinTime: mode === "A" ? RegData.CheckInTime : data.CheckInTime,
        oldcheckoutTime: mode === "A" ? RegData.CheckOutTime : data.CheckOutTime,
        EmplyeeCheckOutDateTime:
            mode === "A" ? RegData.CheckOutTime : data.NewCheckOutTime,
        Status: mode === "A" ? RegData.Status : data.Status,
        AppliedStatus: data.AppliedStatus,
        remarks: mode === "A" ? RegData.Remarks : data.Remarks,
        managerComments: Data.ManagerComments,
    };

    const REGfnSave = async (values, resetForm, del) => {
        setLoading(true);
        let action =
            mode === "A" && !del
                ? "insert"
                : mode === "E" && del
                    ? "harddelete"
                    : "update";
        const idata = {
            RecordID: data.RecordID,
            EmployeeID: mode == "M" ? params.parentID : EMPID,
            RegularizationDate: values.MonthDate,
            CheckInDate: values.CheckInDate,
            CheckOutDate: values.CheckOutDate,
            CheckInTime: values.oldCheckinTime,
            CheckOutTime: values.oldcheckoutTime,
            Status: values.Status,
            Remarks: values.remarks,
            NewCheckInDate: values.CheckInDate,
            NewCheckOutDate: values.CheckOutDate,
            NewCheckInTime: values.EmplyeeCheckInDateTime,
            NewCheckOutTime: values.EmplyeeCheckOutDateTime,
            NewStatus: values.Status,
            AppliedDate: "",
            Reason: "",
            ManagerComments: values.managerComments,
            AppliedStatus:
                mode == "A"
                    ? "AL"
                    : mode == "E" && values.AppliedStatus == "QR"
                        ? "AL"
                        : values.AppliedStatus,
            AssignedBy: "",
            AssignedDate: "",

            // AppliedStatus: mode == "A" ? "AL" : values.AppliedStatus,
            Source: "Cloud",
        };
        const response = await dispatch(
            PermissionApprovalVerify({

                RecordID: recID,
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Status: values.AppliedStatus,
                Type: "RG",
                Password: values.password,
                ManagerComments: values.managerComments ? values.managerComments : ""
            })
        );
        if (response.payload.Status === "Y") {
            dispatch(mailNotify({
                EmployeeID: data.EmployeeID,
                ManagerID: params.managerID,
                Reason: "",
                RecordID: recID,
                Source: "M",
                Status: values.AppliedStatus == "AP" ? "Y" : values.AppliedStatus == "RJ" ? "N" : "Q",
                Type: "RG"
            })
            );
            toast.success(response.payload.Msg);
            navigate(`/approval/notification/RG/${values.AppliedStatus}`);
        } else {
            console.log("🚀 ~ DTSaveFn ~ response.payload.Msg:", response.payload.Msg)
            toast.error(response.payload.Msg);
        }
    };

    async function fileUpload(file, EMPID, action, id, purpose) {
        console.log("🚀 ~ fileUpload ~ file:", file);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("empId", data.EmployeeID);
        formData.append("appId", data.RecordID);
        formData.append("type", "R");
        formData.append("source", "Self");
        formData.append("action", action);
        formData.append("id", id);
        formData.append("purpose", purpose);
        console.log("🚀 ~ fileUpload ~ formData:", formData);
        const respose = await dispatch(attachmentPost({ data: formData }));

        if (respose.payload.success) {
            toast.success(respose.payload.message);

            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: EMPID,
                        appId: recID,
                    },
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError("Failed to fetch attachments.");
                    console.error(err);
                })
                .finally(() => setLoading(false));
        } else {
            toast.success(respose.payload.message);
        }

        console.log("🚀 ~ fileUpload ~ respose:", respose);
    }
    return (
        <React.Fragment>
            {getLoading ? <LinearProgress /> : false}
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
                <Box display="flex" justifyContent="space-between" p={2}>
                    <Box display="flex" borderRadius="3px" alignItems="center">

                        <Typography variant="h5">Regularization</Typography>
                    </Box>
                    <Box display="flex">
                        <IconButton color="error" onClick={() => fnLogOut("Close")}>
                            <ResetTvIcon />
                        </IconButton>
                        <IconButton>
                            <LogoutOutlinedIcon
                                color="error"
                                onClick={() => fnLogOut("Logout")}
                            />
                        </IconButton>
                    </Box>
                </Box>
            </Paper>
            {!getLoading ? (
                <Paper elevation={3} sx={{ margin: "10px" }}>
                    {mode === "IM" && (
                        <Box
                            display="flex"
                            padding={1}
                            justifyContent="flex-end"
                            mt="2px"
                            gridColumn="span 4"
                            gap={2}
                            marginBottom={-5}
                        >
                            <IconButton
                                onClick={() => setShowImage(prev => !prev)}
                            >
                                <ArrowDownwardIcon sx={{ color: "blue" }} />
                            </IconButton>
                        </Box>)}
                    <Formik
                        initialValues={RegInitialValue}
                        onSubmit={(values, { resetForm }) => {
                            setTimeout(() => {
                                REGfnSave(values);
                            }, 100);
                        }}
                        //   validationSchema={OverheadSchema}
                        enableReinitialize={true}
                    >
                        {({
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            isSubmitting,
                            values,
                            handleSubmit,
                            resetForm,
                            setFieldValue,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box
                                    display="grid"
                                    gap={formGap}
                                    padding={1}
                                    gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                                    // gap="30px"
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 2",
                                        },
                                    }}
                                >

                                    <TextField
                                        fullWidth
                                        variant="standard"
                                        type="text"
                                        id="Name"
                                        name="Name"
                                        value={values.Name}
                                        label="Name"
                                        focused
                                        inputProps={{ readOnly: true }}
                                    //sx={{ gridColumn: "span 2" }}
                                    />


                                    <TextField

                                        name="MonthDate"
                                        type="date"
                                        id="MonthDate"
                                        label="Regularization Date"
                                        variant="standard"
                                        focused
                                        inputFormat="YYYY-MM-DD"
                                        value={values.MonthDate}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        error={!!touched.MonthDate && !!errors.MonthDate}
                                        helperText={touched.MonthDate && errors.MonthDate}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ readOnly: true }}
                                    />

                                    <TextField

                                        name="CheckInDate"
                                        type="date"
                                        id="CheckInDate"
                                        label="Check In Date"
                                        variant="standard"
                                        focused
                                        inputFormat="YYYY-MM-DD"
                                        value={values.CheckInDate}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ readOnly: true }}
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            const selectedDate = e.target.value;
                                            if (selectedDate) {
                                                dispatch(
                                                    RegGetData({
                                                        data: {
                                                            EmployeeID: EMPID,
                                                            CheckInDate: selectedDate,
                                                        },
                                                    })
                                                ).then((response) => {
                                                    const msg = response.payload.Msg;
                                                    if (msg) {
                                                        setResponseMsg(msg);
                                                    } else {
                                                        setResponseMsg(""); // Clear if no message
                                                    }
                                                });
                                            }
                                            setCheckIN(selectedDate);
                                            setFieldValue("CheckInDate", selectedDate);
                                        }}
                                        error={!!touched.CheckInDate && !!errors.CheckInDate}
                                        helperText={touched.CheckInDate && errors.CheckInDate}
                                    //sx={{ gridColumn: "span 2" }}
                                    />
                                    <React.Fragment>
                                        <TextField

                                            name="EmplyeeCheckInDateTime"
                                            type="time"
                                            id="EmplyeeCheckInDateTime"
                                            label="Check In Time"
                                            inputFormat="HH:mm"
                                            // inputFormat="HH:mm:aa"
                                            inputProps={{ readOnly: true }}
                                            variant="standard"
                                            value={values.EmplyeeCheckInDateTime}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            focused
                                        //sx={{ gridColumn: "span 2" }}
                                        />

                                        <TextField

                                            name="CheckOutDate"
                                            type="date"
                                            id="CheckOutDate"
                                            label="Check Out Date"
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.CheckOutDate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ readOnly: true }}
                                            error={!!touched.CheckOutDate && !!errors.CheckOutDate}
                                            helperText={touched.CheckOutDate && errors.CheckOutDate}
                                        //sx={{ gridColumn: "span 2", background: "#f5f5f5" }}
                                        />

                                        <TextField

                                            name="EmplyeeCheckOutDateTime"
                                            type="time"
                                            id="EmplyeeCheckOutDateTime"
                                            label="Check Out Time"
                                            inputFormat="HH:mm:aa"
                                            value={values.EmplyeeCheckOutDateTime}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            inputProps={{ readOnly: true }}
                                            focused
                                            variant="standard"
                                        />

                                        <FormControl
                                            focused
                                            variant="standard"
                                        >
                                            <InputLabel id="Status">Status</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-filled-label"
                                                id="Status"
                                                name="Status"
                                                inputProps={{ readOnly: true }}
                                                value={values.Status}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                            >
                                                <MenuItem value="R">Present</MenuItem>
                                                <MenuItem value="A">Absent</MenuItem>
                                                <MenuItem value="W">WeekOff</MenuItem>
                                                <MenuItem value="I">Irregular</MenuItem>
                                                <MenuItem value="L">Leave</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <TextField
                                            select
                                            label="Applied Status"
                                            id="AppliedStatus"
                                            name="AppliedStatus"
                                            value={values.AppliedStatus}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            required
                                            focused

                                            variant="standard"
                                        >
                                            <MenuItem value="AP">
                                                Approved
                                            </MenuItem>
                                            <MenuItem value="RJ">
                                                Rejected
                                            </MenuItem>
                                            <MenuItem value="QR">Query</MenuItem>
                                        </TextField>
                                        <TextField

                                            fullWidth
                                            variant="standard"
                                            type="text"
                                            label="Remarks"
                                            value={values.remarks}
                                            id="remarks"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            name="remarks"
                                            error={!!touched.remarks && !!errors.remarks}
                                            helperText={touched.remarks && errors.remarks}
                                            focused
                                            required
                                            inputProps={{ maxLength: 90, readOnly: true }}
                                        />

                                        <FormControl focused variant="standard">

                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Manager Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.managerComments}
                                                id="managerComments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="managerComments"
                                                sx={{
                                                    gridColumn: "span 2",
                                                }}
                                                focused
                                            />
                                        </FormControl>
                                    </React.Fragment>
                                </Box>
                                <Box
                                    display="flex"
                                    justifyContent="end"
                                    mt="20px"
                                    gap="20px"
                                    padding={1}
                                // flexDirection={isNonMobile ? "row" : "column"}
                                >
                                    {data.AppliedStatus == "AP" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                            Your Regularization request has been Approved.
                                        </Alert>
                                    )}

                                    {data.AppliedStatus == "RJ" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                            Your Regularization request has been Rejected.
                                        </Alert>
                                    )}
                                    {data.AppliedStatus == "QR" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                            Your Regularization request has been Queried.
                                        </Alert>
                                    )}
                                    <TextField
                                        required
                                        name="password"
                                        type="password"
                                        id="password"
                                        label="Password"
                                        variant="standard"
                                        focused
                                        value={values.password}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        fullWidth={isNonMobile ? false : true}
                                        // sx={{ gridColumn: "span 2", width: 300 }}
                                        inputProps={{ readOnly: data.AppliedStatus == "AP" || data.AppliedStatus == "RJ" ? true : false }}
                                    />
                                    <LoadingButton
                                        disabled={data.AppliedStatus == "AP" || data.AppliedStatus == "RJ"}
                                        color="success"
                                        variant="contained"
                                        type="submit"
                                        loading={isLoading}
                                    >
                                        Submit
                                    </LoadingButton>
                                </Box>


                            </form>
                        )}
                    </Formik>
                    <FileListPopup
                        open={open}
                        onClose={() => setOpen(false)}
                        appId={recID}
                        empId={EMPID}
                    />
                </Paper>
            ) : (
                false
            )}

        </React.Fragment>
    );
};
export default Regularizationaproval;
